var AutocompleteType;
(function (AutocompleteType) {
    AutocompleteType["BDAY"] = "bday";
    AutocompleteType["COUNTRY"] = "country";
    AutocompleteType["COUNTRY_NAME"] = "country-name";
    AutocompleteType["CURRENT_PASSWORD"] = "current-password";
    AutocompleteType["EMAIL"] = "email";
    AutocompleteType["IMPP"] = "impp";
    AutocompleteType["LANGUAGE"] = "language";
    AutocompleteType["NAME"] = "name";
    AutocompleteType["NEW_PASSWORD"] = "new-password";
    AutocompleteType["NONE"] = "";
    AutocompleteType["OFF"] = "off";
    AutocompleteType["ON"] = "on";
    AutocompleteType["ONE_TIME_CODE"] = "one-time-code";
    AutocompleteType["ORGANIZATION"] = "organization";
    AutocompleteType["ORGANIZATION_TITLE"] = "organization-title";
    AutocompleteType["PHOTO"] = "photo";
    AutocompleteType["POSTAL_CODE"] = "postal-code";
    AutocompleteType["SEX"] = "sex";
    AutocompleteType["STREET_ADDRESS"] = "street-address";
    AutocompleteType["TEL"] = "tel";
    AutocompleteType["TEL_EXTENSION"] = "tel-extension";
    AutocompleteType["TRANSACTION_AMOUNT"] = "transaction-amount";
    AutocompleteType["TRANSACTION_CURRENCY"] = "transaction-currency";
    AutocompleteType["URL"] = "url";
    AutocompleteType["USERNAME"] = "username";
})(AutocompleteType || (AutocompleteType = {}));
export default AutocompleteType;
//# sourceMappingURL=autocomplete-type.js.map